import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ContentBlock from "../ContentBlock";
import ExhibitionsList from "../ExhibitionsList";
import { exhibitionsApiRequest } from "../../../api";

function Past({ query, heading, id, onFetch, onNextPage }) {
  const defaultExhibitions = [];
  const [exhibitions, setExhibitions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);

  // `defaultExhibitions` shouldn't be a dependency of this effect
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    function onSuccess(response) {
      const hasExhibitions = response.records && response.records.length > 0;
      const pagination = response.pagination;
      const isFirstPage =
        !response.pagination || response.pagination.currentPage === 1;

      setExhibitions((records) =>
        hasExhibitions
          ? isFirstPage
            ? [...response.records]
            : [...records, ...response.records]
          : defaultExhibitions
      );
      setIsLoading(false);
      setHasNextPage(pagination?.totalPages >= pagination?.nextPage);
      onFetch("past", hasExhibitions);
    }

    const fetchData = () => {
      setIsLoading(true);
      exhibitionsApiRequest(
        {
          past: true,
          order: "reverse_chronological",
          ...query,
        },
        onSuccess
      );
    };

    fetchData();
  }, [query]);
  /* eslint-enable react-hooks/exhaustive-deps */

  if (exhibitions.length <= 0) return null;

  return (
    <ContentBlock heading={heading} id={id}>
      <ExhibitionsList
        exhibitions={exhibitions}
        isLoading={isLoading}
        {...(hasNextPage ? { onNextPage } : {})}
      />
    </ContentBlock>
  );
}

Past.displayName = "ExhibitionsLanding.Past";

Past.propTypes = {
  query: PropTypes.object,
  heading: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onFetch: PropTypes.func,
  onNextPage: PropTypes.func,
};

export default Past;
